var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn_action btn_delete",attrs:{"type":"button","disabled":_vm.disabled,"title":"Smazat"},on:{"click":_vm.click}},[_vm._v("Smazat")])}
var staticRenderFns = []

export { render, staticRenderFns }